import i18n from 'i18n';
import {diplomatObjectSchema} from 'types/diplomat-object';
import * as yup from 'yup';

export const ROISettingsNames = {
   transactionMins: 'transactionMins',
   jobMins: 'jobMins',
   pgpMins: 'pgpMins',
   zipMins: 'zipMins',
   keyMins: 'keyMins',
   failureNotificationMins: 'failureNotificationMins',
   hourlyRate: 'hourlyRate',
} as const;

export const ROISettingsLabels = {
   [ROISettingsNames.transactionMins]: i18n.t('Transaction created'),
   [ROISettingsNames.jobMins]: i18n.t('Transaction Executed'),
   [ROISettingsNames.pgpMins]: i18n.t('PGP Operations'),
   [ROISettingsNames.zipMins]: i18n.t('ZIP Operations'),
   [ROISettingsNames.keyMins]: i18n.t('PGP/SSH Key Created'),
   [ROISettingsNames.failureNotificationMins]: i18n.t('Failure Notifications Sent'),
   [ROISettingsNames.hourlyRate]: i18n.t('Average Hourly Rate'),
} as const;

export const ROISettingsSchema = diplomatObjectSchema.shape({
   [ROISettingsNames.transactionMins]: yup.number().min(0, 'transactionMins cannot be negative'),
   // .required('transactionMins is required'),

   [ROISettingsNames.jobMins]: yup.number().min(0, 'jobMins cannot be negative'),
   // .required('jobMins is required'),

   [ROISettingsNames.pgpMins]: yup.number().min(0, 'pgpMins cannot be negative'),
   // .required('pgpMins is required'),

   [ROISettingsNames.zipMins]: yup.number().min(0, 'zipMins cannot be negative'),
   // .required('zipMins is required'),

   [ROISettingsNames.keyMins]: yup.number().min(0, 'keyMins cannot be negative'),
   // .required('keyMins is required'),

   [ROISettingsNames.failureNotificationMins]: yup
      .number()
      .min(0, 'failureNotificationMins cannot be negative'),
   // .required('failureNotificationMins is required'),

   [ROISettingsNames.hourlyRate]: yup.number().min(0, 'hourlyRate cannot be negative'),
   // .required('hourlyRate is required'),
});
